import { Box } from '@chakra-ui/react';

import { DefaultLayout } from '$components/layout/default-layout';

import { Content } from './content';
import { Name } from './name';
import { ProjectSlider } from './project-slider';

export type Category = 'web' | 'mobile' | 'api' | 'other';

export interface Project {
  name: string;
  description: string;
  category: Category;
  url?: string | null;
  repository?: string | null;
  techs: string[];
  thumbnail?: string | null;
  images?: string[];
}

export interface ProjectTemplateProps {
  project: Project;
}

export function ProjectTemplate({ project }: ProjectTemplateProps) {
  return (
    <DefaultLayout>
      <Box pt={{ base: '24px', md: '48px' }}>
        <Name project={project} />
        <ProjectSlider project={project} />
        <Content project={project} />
      </Box>
    </DefaultLayout>
  );
}
